import { CostAndExpenseModel } from '../../cost-expenses/models/cost-expense.model';

export class InvoiceModel {
  public invoiceHashId: string;
  public invoiceID: number;
  public invoiceNumber: string;
  public bookingRefrenceId: string;
  public status: string = 'OPEN';
  public sharedVehicleGroupDriverHashId: string = '';
  public invoiceRequestDateTime: string;
  public invoiceSendDateTime: string;
  public translatedStatus: string = 'OPEN';
  public invoiceDueDateTime: string;
  public invoiceCloseDateTime: string;
  public invoiceCalculationDateTime: string;
  public currencySymbol: string;
  public licencePlate: string;
  public sharedVehicleGroup: string;
  public driverName: string;
  public addressee: string;
  public total: any;
  public ibanAvailable: boolean;
  public directDebitFileDate: string;
  public includeinDirectDebit: boolean;
  public instanceName: string;
  public isChecked: boolean;
  public isDeletable: boolean;
  public isEditable: boolean;
  public isPaymentHistoryView: boolean;
  public startDateTime: string = '';
  public endDateTime: string = '';

  public senderInstanceHashId: string = '';
  public senderCompanyHashId: string = '';
  public addresseeType: string = 'DRIVER';

  public organizationName: string = '';

  public senderName: string;
  public senderAddress: string;
  public addresseeName: string;
  public addresseeAddress: string;

  public driverHashId: string = '';
  public organizationHashId: string = '';
  public isSenderInstance: boolean = false;

  public costAndExpenseList: CostAndExpenseModel[] = [];
  // public totalAmountExVatFormat: string;
  // public totalAmountInVatFormat: string;
  // public totalVatAmountFormat: string;

  public invoiceType: string = '';

  public paymentLink: string = '';

  public invoiceCloseReason: string = '';

  public invoiceReopenReason: string = '';

  public isDueDateChangeEnable: boolean = false;

  public invoiceStatusList: string[] = [''];
  public searchDriverNameList: string[] = [];
  driverHashIdList: string[] = [];
}

export class PaymentHistoryModel {
  public invoiceHashId: string;
  public insertedDateTime: string;
  public status: string;
  public paymentMode: string;
  public totalAmount: string;
  public description: string;
  public startDateTime: string = '';
  public endDateTime: string = '';
}

export class InvoiceStatusUpdateModel {
  public invoiceHashId: string;
  public status: string;
  public reason: string = '';
}

export class InvoiceBasicDetails {
  public invoiceNumber: string;
  public total: string;
  public currencySymbol: string = '';
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/invoice/models/invoice.model.ts